import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export interface GalleryItem {
    id: string;
    image: string;
    title: string;
    titleEn: string;
    description: string;
    descriptionEn: string;
    category: string;
    order: number;
    active: boolean;
    tags: string[];
}

// 分类到翻译key的映射
export const categoryToTranslationKey: { [key: string]: string } = {
    science: "gallery.images.science",
    socialStudies: "gallery.images.socialStudies",
    teamwork: "gallery.images.teamwork",
    art: "gallery.images.art",
    literature: "gallery.images.literature",
    sports: "gallery.images.sports",
    technology: "gallery.images.technology",
    language: "gallery.images.language",
    mathematics: "gallery.images.mathematics",
    music: "gallery.images.music",
    drawing: "gallery.images.drawing",
    default: "gallery.images.default"
};

export const galleryService = {
    // 获取所有活跃的gallery图片，按order排序
    async getActiveGalleryImages(): Promise<GalleryItem[]> {
        try {
            const galleryRef = collection(db, 'gallery');
            const q = query(
                galleryRef,
                where('active', '==', true),
                orderBy('order', 'asc')
            );
            
            const querySnapshot = await getDocs(q);
            const items: GalleryItem[] = [];
            
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    image: data.image || '',
                    title: data.title || '',
                    titleEn: data.titleEn || '',
                    description: data.description || '',
                    descriptionEn: data.descriptionEn || '',
                    category: data.category || '',
                    order: data.order || 0,
                    active: data.active !== false,
                    tags: data.tags || []
                });
            });
            
            return items;
        } catch (error) {
            console.error('获取gallery数据失败:', error);
            return [];
        }
    },

    // 根据分类获取图片
    async getGalleryImagesByCategory(category: string): Promise<GalleryItem[]> {
        try {
            const galleryRef = collection(db, 'gallery');
            const q = query(
                galleryRef,
                where('active', '==', true),
                where('category', '==', category),
                orderBy('order', 'asc')
            );
            
            const querySnapshot = await getDocs(q);
            const items: GalleryItem[] = [];
            
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    image: data.image || '',
                    title: data.title || '',
                    titleEn: data.titleEn || '',
                    description: data.description || '',
                    descriptionEn: data.descriptionEn || '',
                    category: data.category || '',
                    order: data.order || 0,
                    active: data.active !== false,
                    tags: data.tags || []
                });
            });
            
            return items;
        } catch (error) {
            console.error('根据分类获取gallery数据失败:', error);
            return [];
        }
    }
}; 